import { makeStyles, tokens, Tooltip } from "@fluentui/react-components";
import { Checkmark16Regular, Copy16Regular } from "@fluentui/react-icons";
import { useEffect, useState } from "react";

const useStyles = makeStyles({
  copy: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "20px",
    height: "20px",
    padding: 0,
    flexShrink: 0,
    border: "none",
    borderRadius: tokens.borderRadiusSmall,
    backgroundColor: "transparent",
    color: tokens.colorNeutralForeground3,
    cursor: "pointer",
    ":hover": {
      color: tokens.colorNeutralForeground1,
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
    ":active": {
      backgroundColor: tokens.colorNeutralBackground1Pressed,
    },
    ":focus-visible": {
      outline: `2px solid ${tokens.colorStrokeFocus2}`,
      outlineOffset: "1px",
    },
    ":disabled": {
      opacity: 0.4,
      cursor: "default",
    },
  },
});

/** 값 바로 옆의 20px 복사 버튼. 성공하면 잠시 체크 아이콘으로 바뀐다. */
export function CopyIconButton({ value, label }: { value: string; label: string }) {
  const styles = useStyles();
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    setCopied(false);
  }, [value]);
  useEffect(() => {
    if (!copied) return;
    const id = window.setTimeout(() => setCopied(false), 1500);
    return () => window.clearTimeout(id);
  }, [copied]);
  return (
    <Tooltip content={copied ? "복사했습니다" : label} relationship="label">
      <button
        type="button"
        className={styles.copy}
        aria-label={label}
        onClick={() => {
          void navigator.clipboard?.writeText(value).then(
            () => setCopied(true),
            () => setCopied(false),
          );
        }}
      >
        {copied ? <Checkmark16Regular /> : <Copy16Regular />}
      </button>
    </Tooltip>
  );
}
